export default __webpack_public_path__ + "static/media/58.c882fdce.jpeg";